var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOfficeReadonly = function SvgOfficeReadonly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.005,
    height: 15.998,
    viewBox: "0 0 14.005 15.998",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "office_readonly",
    d: "M16367,982a2,2,0,0,1-2-2V968a2,2,0,0,1,2-2h5.677l-2.6,1.5h-2.581a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1v-5.2l1.5-1.176V980a2,2,0,0,1-2,2Zm3-11.5a4.451,4.451,0,1,1,4,2.5A4.455,4.455,0,0,1,16370,970.5Zm2.857,0a1.148,1.148,0,1,0,1.143-1.254A1.2,1.2,0,0,0,16372.857,970.5Z",
    transform: "translate(-16364.998 -966.001)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfficeReadonly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/office_readonly.f9884113.svg";
export { ForwardRef as ReactComponent };